export const MACCS_INTERNSHIPS_MANAGER = {
  SET_REFUSED_MACCS_INTERNSHIP: 'SET_REFUSED_MACCS_INTERNSHIP'
}
